import React from 'react'
import Bennerimg from '../assets/benner.png'

const Benner = () => {
  return (
   <section id='Benner' className='lg:mt-[110px] mt-0'>
<div className='max-w-container mx-auto w-full flex'>


<div  className='w-1/2 h-full bg-white'>
<div className=' pt-[130px]'>
    <button className='w-[179px] h-[37px] border-[1px] border-[#000] border-solid rounded-[20px] flex'>


    <p className='h-[30px] w-[30px] bg-[#FAD0BC] rounded-[50px] ml-[2px]'>
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" className='mx-auto pt-[5px]'>
  <path d="M22.6513 18.0308L22.6511 18.0306C22.5954 17.9707 22.5355 17.9079 22.4723 17.8414C22.0174 17.3639 21.3861 16.7012 20.8608 15.6375C20.2609 14.4229 19.8086 12.714 19.8086 10.1562C19.8086 6.61222 17.3277 3.76924 13.9599 3.06963L13.5616 2.98689V2.58008V1.5625C13.5616 0.975544 13.0859 0.5 12.5 0.5C11.9142 0.5 11.4385 0.975544 11.4385 1.5625V2.58008V2.98689L11.0402 3.06963C7.67235 3.76924 5.19144 6.61222 5.19144 10.1562C5.19144 12.714 4.73912 14.4229 4.13926 15.6375C3.61395 16.7012 2.98271 17.3639 2.52781 17.8414C2.46453 17.9079 2.40466 17.9707 2.34896 18.0306C2.14557 18.2493 2.06091 18.5016 2.06252 18.7466L22.6513 18.0308ZM22.6513 18.0308C22.8543 18.2487 22.9392 18.5013 22.9375 18.7467L22.9375 18.747M22.6513 18.0308L22.9375 18.747M22.9375 18.747C22.9342 19.3027 22.4998 19.8125 21.8701 19.8125H3.12992C2.50053 19.8125 2.06628 19.3029 2.06252 18.7467L22.9375 18.747ZM15.076 22.375C14.8426 23.5858 13.7776 24.5 12.5 24.5C11.2225 24.5 10.1574 23.5858 9.92404 22.375H15.076Z" fill="white" stroke="black"/>
</svg>
    </p> 
    <span className='text-[16px] font-rem font-medium pt-[4px] pl-[12px]'>Startup Business</span>

    </button>

<h1 className='lg:pt-[44px] lg:pl-0 pl-[15px] pt-[55px] lg:text-[36px] text-[32px] font-robot font-medium leading-[45px] text-[black] lg:w-[456px] w-[350px] lg:pb-[32px]'>Empowering startups to fuel
their business growth</h1>
<p className='text-[18px] font-robot font-medium leading-[28px] lg:pl-0 pl-[15px] text-[black] lg:w-[529px] w-[350px] pb-[32px] lg:pt-0 pt-[20px]'>Eu posuere mi sed purus proin quisque molestie. Ut amet, at amet,
 velit <br />
nibh arcu eu. Id sem varius malesuada tincidunt sodales.</p>


<button className='h-[37px] w-[179px] bg-[#EA580C] border-solid border-[0px] rounded-[5px] border-[#EA580C] mt-[25px lg:static lg:ml-0 ml-[15px]' >
  <a href='#' className='text-white font-rem font-normal'>Get started now </a>
        </button>
</div>
</div>



<div className='w-1/2 h-full mx-auto text-center pt-[50px]'>
<img className='mx-auto' src={Bennerimg} alt="benner" />
</div>




</div>

   </section>
  )
}

export default Benner